// TODO: Include types for Bootstrap Toast if available
// @ts-ignore
import Toast from 'bootstrap/js/dist/toast';

export function useToast() {
  function showToast(title: string, message: string, delay = 3000): void {
    const container = document.getElementById('toastContainer');
    if (!container) return;

    // Проверяем количество активных toast'ов
    const activeToasts = container.querySelectorAll('.toast');
    if (activeToasts.length >= 2) {
      // Скрываем самый старый toast (первый в контейнере)
      const oldestToast = activeToasts[0] as HTMLElement;
      // @ts-ignore
      const oldestToastInstance = Toast.getInstance(oldestToast);
      if (oldestToastInstance) {
        oldestToastInstance.hide();
      }
    }

    const toastEl = document.createElement('div');
    toastEl.className = 'toast';
    toastEl.setAttribute('role', 'alert');
    toastEl.setAttribute('aria-live', 'assertive');
    toastEl.setAttribute('aria-atomic', 'true');
    toastEl.innerHTML = `
            <div class="toast-header">
                <strong class="me-auto">${title}</strong>
                <small>Now</small>
                <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Закрыть"></button>
            </div>
            <div class="toast-body">
                ${message}
            </div>
        `;

    container.appendChild(toastEl);

    // Bootstrap 5 Toast
    // @ts-ignore
    const toastInstance = new Toast(toastEl, { autohide: true, delay: delay });
    toastInstance.show();

    toastEl.addEventListener('hidden.bs.toast', () => {
      toastEl.remove();
    });
  }

  return {
    showToast
  };
}
